<template>
  <div class="container-fluid">
    <OverlayLoading :isLoading="loading" />
    
    <div class="tabs">
      <ul class="nav nav-tabs nav-justified">
        <li class="nav-item">
          <a class="nav-link active" :data-bs-target="`#language-settings`" :href="`#language-settings`" data-bs-toggle="tab">Edit Meeting
            <span v-if="this.error_translation_tab"><span class="tab_error">Errors(*)</span></span>
            <span v-if="this.error_general_tab"><span class="tab_error">Errors(*)</span></span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :data-bs-target="`#edit_hosts`" :href="`#edit_hosts`" data-bs-toggle="tab">Edit Hosts</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :data-bs-target="`#room_sessions`" :href="`#room_sessions`" data-bs-toggle="tab">Edit Room Sessions</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :data-bs-target="`#match-making`" :href="`#match-making`" data-bs-toggle="tab">Match Making</a>
        </li>
      </ul>
      
      <div class="tab-content">
        <div :id="`language-settings`" class="tab-pane active">
          <div class="snippet general-event-config-snippet">
            <tabs>
              <tab name="Language">
                <div class="form-group row">
                  <div class="col-lg-6">
                    <label>Language *</label>
                    <v-select required :rules="requiredRule" name="language" class="" placeholder="Select language" 
                      label="language" @option:selected="updateLaguage" :options="languages" 
                      :modelValue="selectedLanguageKey" />
                    <ValidationMessages :element="v$.item.translations" />
                  </div>
                  <div class="col-lg-6">
                    <label>Title *</label>
                    <div class="kt-input-icon">
                      <input type="text" class="form-control" name="title" maxlength="200" 
                        placeholder="Enter language title" :value="getLanguageTitle()" @input="updateLanguageTitle" />
                    </div>
                    <ValidationMessages :element="v$.item.translations" />
                  </div>
                  <div class="form-group row">
                    <div class="col-lg-12">
                      <label>Description</label>
                      <div class="kt-input-icon">
                        <textarea rows="3" class="form-control" name="description" 
                          placeholder="Enter language description" :value="getLanguageDescription()" 
                          @input="updateLanguageDescription" />
                      </div>
                    </div>
                  </div>
                </div>
              </tab>
              
              <tab name="General Settings">
                <div class="snippet general-event-config-snippet">
                  <br/> 
                  
                  <!-- Single Day View -->
                  <div class="form-group row" v-if="event_days.length === 1">
                    <div class="col-lg-6">
                      <label>Room Start Time *</label>
                      <div class="input-daterange input-group">
                        <span class="input-group-text">
                          <i class="fas fa-calendar-alt"></i>
                        </span>
                        <VueTimepicker :format="timeFormat"
                          name="start_time" 
                          :modelValue="item.start_time ? item.start_time : null"
                          placeholder="Room Start Time"
                          @change="updateStart_time"
                        />
                      </div>
                      <ValidationMessages :element="v$.item.start_time"/>
                    </div>
                    <div class="col-lg-4">
                      <label class>Room End Time *</label>
                      <div class="input-daterange input-group">
                        <span class="input-group-text">
                          <i class="fas fa-calendar-alt"></i>
                        </span>
                        <VueTimepicker 
                          :modelValue="item.end_time ? item.end_time : null"
                          :format="timeFormat" 
                          name="end_time" 
                          :config="getEndRoomTimeConfig()"
                          placeholder="Room End Time"
                          @change="updateEnd_time"
                        />
                      </div>
                      <ValidationMessages :element="v$.item.end_time"/>
                    </div>
                    <div class="col-lg-2">
                      <label class>Meeting Duration *</label>
                      <div class="input-daterange input-group">
                        <span class="input-group-text"></span>
                        <input 
                          type="number"
                          class="form-control minutes_input"
                          name="time_slot"
                          placeholder="Enter Time slot"
                          :value="item.time_slot"
                          @input="updateTime_slot"
                          min="0"
                        />
                      </div>
                      <ValidationMessages :element="v$.item.time_slot"/>
                    </div>
                  </div>

                  <div class="form-group row" v-if="event_days.length === 1">
                    <div class="col-lg-3">
                      <label>Limited Room Sessions ?</label>
                      <br />
                      <div class="switch switch-sm switch-primary">
                        <input-switch name="limited_sessions" 
                          :value="item.limited_sessions" 
                          id="customEETR" 
                          class="custom-control-input" 
                          @change="updateLimitedSessions" />
                        <label class="custom-control-label" for="customERR"></label>
                      </div>
                    </div>
                    <div class="col-lg-3" v-if="item.limited_sessions">
                      <label>Number of sessions*</label>
                      <input
                        type="number"
                        class="form-control"
                        name="no_of_sessions"
                        maxlength="191"
                        min="0"
                        placeholder="Enter Number"
                        :value="item.no_of_sessions"
                        @input="updateNoOfSessions"
                      />
                    </div>
                  </div>

                  <!-- Enhanced Multi-Day Tabs with Pagination -->
                  <div v-if="event_days.length > 1">
                    <div class="days-tabs-container">
                      <!-- Tab Navigation with Scroll/Pagination -->
                      <div class="days-tabs-nav">
                        <button 
                          class="nav-arrow nav-arrow-prev" 
                          @click="scrollDaysTabs('prev')"
                          :disabled="daysTabScrollPosition === 0"
                          v-show="showDaysNavArrows"
                        >
                          <i class="fas fa-chevron-left"></i>
                        </button>
                        
                        <div class="days-tabs-scroll-wrapper" ref="daysTabsScrollWrapper">
                          <div class="days-tabs" ref="daysTabs">
                            <button
                              v-for="(day, index) in paginatedDays"
                              :key="getActualDayIndex(index)"
                              :class="['day-tab', { active: activeDayIndex === getActualDayIndex(index) }]"
                              @click="setActiveDay(getActualDayIndex(index))"
                            >
                              {{ truncateDayName(day) }}
                              <span v-if="hasDayErrors(getActualDayIndex(index))" class="day-error-badge">!</span>
                            </button>
                          </div>
                        </div>
                        
                        <button 
                          class="nav-arrow nav-arrow-next" 
                          @click="scrollDaysTabs('next')"
                          :disabled="daysTabScrollEndReached"
                          v-show="showDaysNavArrows"
                        >
                          <i class="fas fa-chevron-right"></i>
                        </button>
                      </div>
                      
                      <!-- Page Info and Quick Navigation -->
                      <div class="days-tabs-info">
                        <div class="days-info-left">
                          <span class="days-counter">
                            Day {{ activeDayIndex + 1 }} of {{ event_days.length }}
                          </span>
                          <span v-if="totalDayPages > 1" class="page-counter">
                            Page {{ currentPage }} of {{ totalDayPages }}
                          </span>
                        </div>
                        <div class="days-info-right">
                          <select v-model="activeDayIndex" @change="scrollToDay" class="day-jump-select">
                            <option v-for="(day, index) in event_days" :key="index" :value="index">
                              Jump to: Day {{ index + 1 }} - {{ truncateDayName(day, 30) }}
                              {{ hasDayErrors(index) ? '(Has Errors)' : '' }}
                            </option>
                          </select>
                        </div>
                      </div>
                      
                      <!-- Day Content -->
                      <div class="day-content">
                        <div v-for="(day, i) in event_days" 
                             v-show="activeDayIndex === i" 
                             :key="i"
                             class="day-content-pane">
                          <div class="form-group row">
                            <div class="col-lg-6">
                              <label>Meetings for this day ?</label>
                              <br />
                              <div class="switch switch-sm switch-primary">
                                <input-switch
                                  name="is_rating5"
                                  :id="'customMeetingHas' + i"
                                  :value="getRoomSettingValue(i, 'has_meetings')"
                                  class="custom-control-input"
                                  @change="updateHasMeetings($event, i)"
                                />
                                <label class="custom-control-label" :for="'customMeetingHas' + i"></label>
                              </div>
                            </div>
                          </div>

                          <div class="form-group row" v-if="getRoomSettingValue(i, 'has_meetings')">
                            <div class="col-lg-4">
                              <div class="col-lg-12">
                                <label for="start_time">Room Start Time *</label>
                              </div>
                              <VueTimepicker
                                :modelValue="getRoomSettingValue(i, 'start_time')"
                                :format="timeFormat"
                                name="start_time"
                                placeholder="Room Start Time"
                                @change="updateStart_timeDay($event, i)"
                              />
                            </div>
                            <div class="col-lg-4">
                              <div class="col-lg-12">
                                <label for="end_time">Room End Time *</label>
                              </div>
                              <VueTimepicker
                                :modelValue="getRoomSettingValue(i, 'end_time')"
                                :format="timeFormat"
                                :config="getEndRoomTimeConfig()"
                                name="end_time"
                                placeholder="Enter Room Day End Time"
                                @change="updateEnd_timeDay($event, i)"
                              />
                            </div>
                            <div class="col-lg-3">
                              <label for="time_slot">Meeting slot *</label>
                              <input
                                type="number"
                                class="form-control minutes_input"
                                name="time_slot"
                                placeholder="Enter Time slot"
                                :value="getRoomSettingValue(i, 'time_slot')"
                                @input="updateTime_slotDay($event, i)"
                                min="0"
                              />
                            </div>
                          </div>
                          
                          <div class="form-group row" v-if="getRoomSettingValue(i, 'has_meetings')">
                            <div class="col-lg-3">
                              <label>Limited Room Sessions ?</label>
                              <br />
                              <div class="switch switch-sm switch-primary">
                                <input-switch
                                  name="is_rating1"
                                  :id="'customERR' + i"
                                  :checked="getRoomSettingValue(i, 'limited_sessions')"
                                  :value="getRoomSettingValue(i, 'limited_sessions')"
                                  class="custom-control-input"
                                  @change="updateLimitedSessionsDay($event, i)"
                                />
                                <label class="custom-control-label" :for="'customERR' + i"></label>
                              </div>
                            </div>
                            <div class="col-lg-3" v-if="getRoomSettingValue(i, 'limited_sessions')">
                              <label for="room_no">Number of sessions*</label>
                              <input
                                type="number"
                                class="form-control"
                                name="no_of_sessions"
                                maxlength="191"
                                min="0"
                                placeholder="Enter Number"
                                :value="getRoomSettingValue(i, 'no_of_sessions')"
                                @input="updateNoOfSessionsDay($event, i)"
                              />
                            </div>
                          </div>
                          
                          <div class="form-group row" v-if="getRoomSettingValue(i, 'has_meetings')">
                            <div class="col-md-6">
                              <div class="row">
                                <div class="col-lg-6" v-show="!getRoomSettingValue(i, 'is_no_break')">
                                  <label for="start_time">Room Break Start Time *</label>
                                  <VueTimepicker
                                    :modelValue="getRoomSettingValue(i, 'break_start_time')"
                                    :format="timeFormat"
                                    name="break_start_time"
                                    placeholder="Break Start Time"
                                    @change="updateBreak_Start_timeDay($event, i)"
                                  />
                                </div>
                                <div class="col-lg-6" v-show="!getRoomSettingValue(i, 'is_no_break')">
                                  <label for="end_time">Room Break End Time *</label>
                                  <VueTimepicker
                                    :modelValue="getRoomSettingValue(i, 'break_end_time')"
                                    :format="timeFormat"
                                    name="break_end_time"
                                    placeholder="Break End Time"
                                    @change="updateBreak_End_timeDay($event, i)"
                                  />
                                </div>
                                <div class="col-lg-12">
                                  <label for="no_break" class="mt-2">There is no break</label>
                                  <div class="switch switch-sm switch-primary">
                                    <input-switch
                                      :id="'no_break' + i"
                                      class="custom-control-input"
                                      :checked="getRoomSettingValue(i, 'is_no_break')"
                                      :value="getRoomSettingValue(i, 'is_no_break')"
                                      @change="changeNoBreakDay($event, i)"
                                    />
                                    <label :for="'no_break' + i" class="custom-control-label"></label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Single Day Break Settings -->
                  <div class="form-group row" v-if="event_days.length === 1">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-lg-6" v-if="!item.is_no_break">
                          <label for="start_time">Room Break Start Time *</label>
                          <VueTimepicker
                            :modelValue="item.break_start_time ? item.break_start_time : null"
                            :format="timeFormat"
                            name="break_start_time"
                            placeholder="Break Start Time"
                            @change="updateBreak_Start_time"
                          />
                        </div>
                        <div class="col-lg-6" v-if="!item.is_no_break">
                          <label for="end_time">Room Break End Time</label>
                          <VueTimepicker
                            :modelValue="item.break_end_time ? item.break_end_time : null"
                            :format="timeFormat"
                            :config="getEndRoomBreakTimeConfig()"
                            name="break_end_time"
                            placeholder="Break End Time"
                            @change="updateBreak_End_time"
                          />
                        </div>
                        <div class="col-lg-12">
                          <label for="no_break" class="mt-2">There is no break</label>
                          <div class="switch switch-sm switch-primary">
                            <input-switch
                              id="no_break"
                              class="custom-control-input"
                              type="checkbox"
                              :value="item.is_no_break"
                              @change="changeNoBreak"
                            />
                            <label for="no_break" class="custom-control-label"></label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <label>Screen Sharing ?</label>
                      <br />
                      <div class="switch switch-sm switch-primary">
                        <input-switch
                          type="checkbox"
                          name="is_rating2"
                          id="customEETT"
                          :value="item.screen_sharing"
                          class="custom-control-input"
                          @change="updateScreenSharing"
                        />
                        <label class="custom-control-label" for="customEETT"></label>
                      </div>
                    </div>
                  </div>

                  <!-- Common Settings -->
                  <div class="form-group row">
                    <div class="col-lg-6">
                      <label>Live Streaming ?</label>
                      <br />
                      <div class="switch switch-sm switch-primary">
                        <input-switch
                          name="is_rating3"
                          id="customEEL"
                          :value="item.is_live_stream"
                          class="custom-control-input"
                          @change="updateIsLiveStream"
                        />
                      </div>
                      <label class="custom-control-label" for="customEETT" style="padding-left: 1em;">
                        {{ item.is_live_stream ? "Enabled" : "Disabled" }}
                      </label>
                    </div>
                    <div class="col-lg-6" v-if="item.is_live_stream">
                      <label for="title">Stream URL</label>
                      <VPopper hover style="display:inline-block">
                        <i class="fa fa-info-circle" style="font-size:16px"></i>
                        <template #content>
                          <img src="/assets/img/live_stream_url.jpg"/>
                        </template>
                      </VPopper>
                      <div class="kt-input-icon">
                        <input
                          type="text"
                          class="form-control"
                          name="stream_url"
                          placeholder="Enter Live Stream URL"
                          :value="item.stream_url"
                          @input="updateStreamUrl"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="col-md-2">
                      <label for="preset_image">Screen Logo *</label>
                    </div>
                    <div class="col-md-10">
                      <DropFiles :file="item.logo"
                        :module_id="item._id"
                        @onUploaded="updateLogo"
                        @onRemoved="removeLogo"
                        @onError="errCb"
                        :accept="'image/jpeg'"
                        dimmention="455X256"
                        :module_type="'meetings'"
                        :asset_type="'meetings'">
                        <template #header>
                          <p>(Size should be 455x256 pixel and format jpg.)</p>
                        </template>
                      </DropFiles>
                    </div>
                    <ValidationMessages :element="v$.item.logo" />
                  </div>

                  <div class="form-group row">
                    <div class="col-md-2">
                      <label for="preset_image">Background Banner</label>
                    </div>
                    <div class="col-md-10">
                      <DropFiles :file="item.background_banner"
                        :module_id="item._id"
                        @onUploaded="updateBackgroundBanner"
                        @onRemoved="removeBackgroundBanner"
                        @onError="errCb"
                        :accept="'image/jpeg'"
                        dimmention="1200X400"
                        :module_type="'meetings'"
                        :asset_type="'meetings'">
                        <template #header>
                          <p>(Size should be 1200x400 pixel and format jpg.)</p>
                        </template>
                      </DropFiles>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="col-lg-2">
                      <label>Skybox</label>
                      <br />
                      <div class="custom-control custom-switch">
                        <input-switch name="skybox_is_custom" :value="item.skybox_is_custom" 
                          id="customSwitchesEx" class="custom-control-input" @change="updateSkybox_is_custom" />
                        <label class="custom-control-label" for="customEF">
                          {{ item.skybox_is_custom ? 'Custom' : 'Pre Defined' }}
                        </label>
                      </div>
                    </div>
                    <div class="col-lg-4" v-show="item.skybox_is_custom">
                      <DropFiles :file="item.skybox_picture" 
                        :module_id="item._id" 
                        dimmention="4096X4096"
                        @onUploaded="updateSkyboxPicture" 
                        @onRemoved="removeSkyboxPicture"
                        :accept="'image/jpeg'"
                        module_type="meetings" 
                        asset_type="skybox_picture"  
                        @onError="errCb">
                        <template #header>
                          <label>Sky box Picture (Size should be 4096x4096 pixel and format JPG.)</label>
                        </template>
                        <template #tooltip>
                          <VTooltip style="display:inline-block">
                            <i class="fa fa-info-circle" style="font-size:16px"></i>
                            <template #popper>
                              <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
                            </template>
                          </VTooltip>
                        </template>
                      </DropFiles>
                    </div>
                    <div class="form-group col-lg-4" v-show="!item.skybox_is_custom">
                      <label class>Sky Box:</label>
                      <div>
                        <select class="form-control" @change="updateSkybox">
                          <option value="" selected>Select</option>
                          <option v-for="option in skyboxes" :value="option.id" :key="option.id"
                            :selected="(item.skybox == option.id)">
                            {{ option.title }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="col-lg-2">
                      <label>Environment</label>
                      <br />
                      <input-switch name="environment_is_custom" :value="item.environment_is_custom" 
                        id="customSwitchesEx" class="custom-control-input" @change="updateEnvironment_is_custom" />
                      <label class="custom-control-label" for="customEG">
                        {{ item.environment_is_custom ? 'Custom' : 'Pre Defined' }}
                      </label>
                    </div>
                    <div class="col-lg-4" v-show="item.environment_is_custom">
                      <DropFiles :file="item.environment_picture" 
                        :module_id="item._id" 
                        dimmention="6000X1113"
                        @onUploaded="updateEnvironmentPicture" 
                        @onRemoved="removeEnvironmentPicture"
                        :accept="'image/png'"
                        module_type="meetings" 
                        asset_type="environment_picture"  
                        @onError="errCb">
                        <template #header>
                          <label>Environment Picture (Size should be 6000x1113 pixel and format PNG.)</label>
                        </template>
                        <template #tooltip>
                          <VTooltip style="display:inline-block">
                            <i class="fa fa-info-circle" style="font-size:16px"></i>
                            <template #popper>
                              <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
                            </template>
                          </VTooltip>
                        </template>
                      </DropFiles>
                    </div>
                    <div class="form-group col-lg-4" v-show="!item.environment_is_custom">
                      <label class>Environment:</label>
                      <div>
                        <select class="form-control" @change="updateEnvironment">
                          <option value="" selected>Select</option>
                          <option v-for="option in environments" :value="option.id" :key="option.id"
                            :selected="(item.environment == option.id)">
                            {{ option.title }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="containter eventhall_flags">
                      <div class="form-group row">
                        <label class>Long Banners:</label>
                        <div class="col-lg-12">
                          <div id="multiple_images">
                            <input
                              placeholder="Upload Multiple Images (Max limit 4)"
                              type="file"
                              class="form-control"
                              @change="updateVerticalBanners"
                              multiple="multiple"
                              accept="image/jpeg"
                            />
                            <span>Upload Multiple Long Banners (Max Limit 4 & Suggested Resolution:360x900)</span>
                          </div>
                        </div>
                        <div class="image-list">
                          <div class="image-item" v-for="file in item.vertical_banners" v-bind:key="file.key">
                            <img :src="IMAGE_URL + file.key" alt="Image">
                            <div class="image-details">
                              <span class="image-name">{{ getFileName(file.key) }}</span>
                              <button type="button" class="remove-btn" @click="removeVerticalBannerAsset($event, file.key)">Remove</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </tab>
            </tabs>
          </div>
        </div>

        <div :id="`edit_hosts`" class="tab-pane">
          <MeetingRoomHost :item="item" :meetingId="item._id" :event_timezone="event_timezone"/>
        </div>

        <div :id="`room_sessions`" class="tab-pane">
          <MeetingRoomSession :item="item" :meetingId="item._id" :event_timezone="event_timezone"/>
        </div>

        <div :id="'match-making'" class="tab-pane">
          <MatchMakingTab
            v-if="item && item._id"
            ref="matchMakingTab"
            :module-id="item._id"
            :event-id="item.event_id"
            module-name="Meeting"
            module-display-name="Meetings"
            :max-tags="200"
            :required="false"
            :auto-save="false"
            :show-save-button="true"
            @saved="onMatchMakingSaved"
          />
        </div>
      </div>

      <div class="card-body text-right mt-3 mr-5">
        <button type="button" class="mb-1 mt-1 me-1 btn btn-lg btn-primary" @click="submitForm">Save</button>
        <button type="button" class="mb-1 mt-1 me-1 btn btn-lg btn-secondary" @click="cancelClick">Cancel</button>
      </div>
    </div>
  </div>
  <FlashMessage group="meetings_edit" />
</template>

<script>
import MeetingRoomSession from "@/components/cruds/Meetings/RoomSessions/index"
import MeetingRoomHost from "@/components/cruds/Meetings/Hosts/Index"
import moment from 'moment';
import { gettingErrorMessage } from "@/services/GetValidationMessage";
import { mapGetters, mapActions } from "vuex";
import $ from 'jquery';
import InputSwitch from "@/components/Commons/InputSwitch";
import _ from "lodash";
import ObjectID from 'bson-objectid';
import DropFiles from "@/components/Commons/DropFiles";
import { v4 as uuidv4 } from 'uuid';
import ValidationMessages from "@/components/Commons/Validations/ValidationMessages";
import { isPermits } from "@/services/CheckPermissions";
import constants from "@/config/constants";
import MatchMakingTab from "@/components/Commons/MatchMaking/MatchMakingTab.vue";
import { upload, remove } from "@/services/FileUploader";
import { useVuelidate } from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';

export default {
  name: "MeetingRoomEditForm",
  components: {
    InputSwitch,
    ValidationMessages,
    MeetingRoomSession,
    MeetingRoomHost,
    MatchMakingTab
  },
  props: {
    languages: {
      type: Array,
    }
  },
  data() {
    return {
      IMAGE_URL: constants.IMAGE_URL,
      moduleId: ObjectID(),
      translation: [],
      languageKey: null,
      questionList: true,
      setIsSubEditing: false,
      edit_id: null,
      selectedLanguage: null,
      id: null,
      timeFormat: 'HH:mm',
      // Day tabs pagination properties
      activeDayIndex: 0,
      daysTabScrollPosition: 0,
      daysPerPage: 8,
      daysTabScrollWrapper: null,
      daysTabContainer: null,
      resizeObserver: null,
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  validations() {
    return {
      item: {
        translations: { required },
        logo: { required },
      }
    };
  },
  beforeUnmount() {
    this.resetState();
    delete this.$flashMessage.groups.meetings_edit;
    window.removeEventListener('resize', this.handleResize);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  created() {
    this.fetchEventsAllEdit(this.$route.params.event_id);
    this.setMeetingId(this.item._id);
  },
  mounted() {
    this.initDaysTabs();
    window.addEventListener('resize', this.handleResize);
  },
  computed: {
    ...mapGetters('MeetingRoomsIndex', ['event_timezone', 'booths']),
    ...mapGetters('MeetingRoomsSingle', [
      'error_translation_tab',
      'error_general_tab',
      'meetingId',
      'event_days',
      'item',
      'loading',
      'eventID',
      'selectedLanguageKey',
      'selectedLanguageTitle',
      'selectedLanguageDescirption',
      "skyboxes",
      "environments"
    ]),
    
    paginatedDays() {
      const start = this.daysTabScrollPosition;
      const end = start + this.daysPerPage;
      return this.event_days.slice(start, end);
    },
    
    showDaysNavArrows() {
      return this.event_days.length > this.daysPerPage;
    },
    
    daysTabScrollEndReached() {
      return this.daysTabScrollPosition + this.daysPerPage >= this.event_days.length;
    },
    
    totalDayPages() {
      return Math.ceil(this.event_days.length / this.daysPerPage);
    },
    
    currentPage() {
      return Math.floor(this.daysTabScrollPosition / this.daysPerPage) + 1;
    }
  },
  methods: {
    ...mapActions('MeetingRoomsIndex', {
      fetchAllData: 'fetchData',
    }),
    ...mapActions('MeetingRoomsSingle', [
      'fetchEventsAllEdit',
      'setMeetingId',
      'storeData',
      'fetchData',
      'resetState',
      'setLangKey',
      'setLangTitle',
      'setLangDescirption',
      'setTranslations',
      'setBooth',
      'setLogo',
      'setEvent',
      'setTime_slot',
      'setTime_slotDay',
      'setHours_per_day',
      'setEnd_time',
      'setStart_time',
      'setEnd_date',
      'setStart_date',
      'setEnd_timeDay',
      'setBreak_Start_time',
      'setBreak_Start_timeDay',
      'setBreak_End_time',
      'setBreak_End_timeDay',
      'setStart_timeDay',
      'setIsNoBreakDay',
      'setHasMeetings',
      'setLimitedSessionsDay',
      'setScreenSharing',
      'setIsLiveStream',
      'setIsBackgroundPicture',
      'setBackgroundPicture',
      'setBackgroundStripesColor',
      'setBackgroundColor',
      'setRoomLogo',
      'setBanner',
      'setShowText',
      'setDescription',
      'setDocument1',
      'setDocument2',
      'setDocument3',
      'setInterprefy',
      'setInterprefyToken',
      'setAwsInterpretation',
      'setAwsEnableSpeechToSpeech',
      'setAwsEnableSpeechToText',
      'setChat',
      'setNoOfSessions',
      'setIsNoBreak',
      'setLimitedSessions',
      'setErrorTranslationTab',
      'setErrorGeneralTab',
      'setNoOfSessionsDay',
      'updateData',
      'setStreamUrl',
      'setSkybox_is_custom',
      'setEnvironment_is_custom',
      'setSkyboxPicture',
      'setEnvironmentPicture',
      'setSkybox',
      'setEnvironment',
      'setBackgroundBanner',
      'setVerticalBanners',
      'removeVerticalBanners',
    ]),
    
    getRoomSettingValue(dayIndex, field) {
      if (this.item.room_settings && this.item.room_settings[dayIndex]) {
        return this.item.room_settings[dayIndex][field];
      }
      return null;
    },
    
    getFileName(str) {
      let stringNew = str.split("/").pop();
      return stringNew.slice(-20);
    },
    
    updateStreamUrl(e) {
      this.setStreamUrl(e.target.value);
    },
    
    updateNoOfSessionsDay(e, i) {
      this.setNoOfSessionsDay({ value: e.target.value, i: i });
      this.$forceUpdate();
    },
    
    updateLimitedSessions(e) {
      this.setLimitedSessions(e.target.checked);
    },
    
    updateNoOfSessions(e) {
      this.setNoOfSessions(e.target.value);
    },
    
    getEndRoomBreakTimeConfig() {
      let minDate = this.item.break_start_time
        ? moment(this.item.break_start_time, 'HH:mm').add(1, 'minute')
        : moment();
      return Object.assign({}, 'HH:mm', {
        minDate: minDate.isValid() ? minDate : moment()
      });
    },
    
    updateChat(e) {
      this.setChat(e.target.checked);
    },
    
    updateShowText(e) {
      this.setShowText(e.target.checked);
    },
    
    updateDescription(e) {
      this.setDescription(e.target.value);
    },
    
    updateBackgroundStripesColor(e) {
      this.setBackgroundStripesColor(e.target.value);
      this.$forceUpdate();
    },
    
    updateBackgroundColor(e) {
      this.setBackgroundColor(e.target.value);
      this.$forceUpdate();
    },
    
    updateIsBackgroundPicture(e) {
      this.setIsBackgroundPicture(e.target.checked);
    },
    
    updateIsLiveStream(e) {
      this.setIsLiveStream(e.target.checked);
    },
    
    updateScreenSharing(e) {
      this.setScreenSharing(e.target.checked);
    },
    
    updateLimitedSessionsDay(e, i) {
      this.setLimitedSessionsDay({ value: e.target.checked, i: i });
      this.$forceUpdate();
    },
    
    updateHasMeetings(e, day) {
      this.setHasMeetings({ value: e.target.checked, i: day });
      this.$forceUpdate();
    },
    
    changeNoBreak(e) {
      this.setIsNoBreak(e.target.checked);
      this.setBreak_Start_time(null);
      this.setBreak_End_time(null);
      this.$forceUpdate();
    },
    
    changeNoBreakDay(e, i) {
      this.setIsNoBreakDay({ value: e.target.checked, i: i });
      this.setBreak_Start_timeDay({ time: null, i: i });
      this.setBreak_End_timeDay({ time: null, i: i });
      this.$forceUpdate();
    },
    
    updateEnd_timeDay(e, i) {
      this.setEnd_timeDay({ time: e.displayTime, i: i });
      this.$forceUpdate();
    },
    
    updateBreak_Start_time(e) {
      this.setBreak_Start_time(e.displayTime);
    },
    
    updateBreak_Start_timeDay(e, i) {
      this.setBreak_Start_timeDay({ time: e.displayTime, i: i });
      this.$forceUpdate();
    },
    
    updateBreak_End_time(e) {
      this.setBreak_End_time(e.displayTime);
    },
    
    updateBreak_End_timeDay(e, i) {
      this.setBreak_End_timeDay({ time: e.displayTime, i: i });
      this.$forceUpdate();
    },
    
    updateStart_timeDay(e, i) {
      console.log("Update start time", e.displayTime, i);
      this.setStart_timeDay({ time: e.displayTime, i: i });
      this.$forceUpdate();
    },
    
    updateStart_date(e) {
      this.setStart_date(e.displayTime);
    },
    
    updateEnd_date(e) {
      this.setEnd_date(e.displayTime);
    },
    
    updateStart_time(e) {
      this.setStart_time(e.displayTime);
    },
    
    updateEnd_time(e) {
      this.setEnd_time(e.displayTime);
    },
    
    updateTime_slotDay(e, i) {
      this.setTime_slotDay({ value: e.target.value, i: i });
      this.$forceUpdate();
    },
    
    updateHours_per_day(e) {
      this.setHours_per_day(e.target.value);
    },
    
    updateTime_slot(e) {
      this.setTime_slot(e.target.value);
    },
    
    updateEvent(value) {
      this.setEvent(value);
    },
    
    getEndRoomTimeConfig() {
      let minDate = this.item.start_time
        ? moment(this.item.start_time, 'HH:mm').add(1, 'minute')
        : moment();
      return Object.assign({}, this.$root.dpconfigTime, {
        minDate: minDate.isValid() ? minDate : moment()
      });
    },
    
    updateBooth(value) {
      this.setBooth(value.id);
    },
    
    errCb(e) {
      this.$flashMessage.show({
        group: 'meetings_edit',
        type: 'error',
        title: 'Error Invalid File Format',
        time: 1000,
        html: '<ul><li>Please upload the valid format.</li></ul>'
      });
    },
    
    updateLogo(info, data) {
      if (!_.has(data, 'data.key')) {
        return;
      }
      const extension = data.data.key.split('.').pop();
      const key = _.get(this.item.logo, 'key', null);
      const size = _.get(info, 'file.size', 0);
      this.setLogo({
        old_key: key,
        key: data.data.key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    
    removeLogo() {
      this.setLogo(null);
    },
    
    updateBackgroundBanner(info, data) {
      console.log("data", data, "info**", info);
      if (!_.has(data, 'data.key')) {
        return;
      }
      const extension = data.data.key.split('.').pop();
      const key = _.get(this.item.background_banner, 'key', null);
      const size = _.get(info, 'file.size', 0);
      this.setBackgroundBanner({
        old_key: key,
        key: data.data.key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01'
      });
    },
    
    removeBackgroundBanner() {
      this.setBackgroundBanner(null);
    },
    
    updateBackgroundPicture(info, data) {
      if (!_.has(data, 'data.key')) {
        return;
      }
      const extension = data.data.key.split('.').pop();
      const key = _.get(this.item.videos, 'key', null);
      const size = _.get(info, 'file.size', 0);
      this.setBackgroundPicture({
        old_key: key,
        key: data.data.key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    
    removeBackgroundPicture() {
      this.setBackgroundPicture(null);
    },
    
    updateBanner(info, data) {
      if (!_.has(data, 'data.key')) {
        return;
      }
      const extension = data.data.key.split('.').pop();
      const key = _.get(this.item.banner, 'key', null);
      const size = _.get(info, 'file.size', 0);
      this.setBanner({
        old_key: key,
        key: data.data.key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    
    removeBanner() {
      this.setBanner(null);
    },
    
    updateRoomLogo(info, data) {
      if (!_.has(data, 'data.key')) {
        return;
      }
      const extension = data.data.key.split('.').pop();
      const key = _.get(this.item.room_logo, 'key', null);
      const size = _.get(info, 'file.size', 0);
      this.setRoomLogo({
        old_key: key,
        key: data.data.key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    
    removeRoomLogo() {
      this.setRoomLogo(null);
    },
    
    updateDocument1(info, data) {
      if (!_.has(data, 'data.key')) {
        return;
      }
      const extension = data.data.key.split('.').pop();
      const key = _.get(this.item.document1, 'key', null);
      const size = _.get(info, 'file.size', 0);
      this.setDocument1({
        old_key: key,
        key: data.data.key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    
    removeDocument1() {
      this.setDocument1(null)
      this.setDocumentSlide1([]);
    },
    
    updateDocument2(info, data) {
      if (!_.has(data, 'data.key')) {
        return;
      }
      const extension = data.data.key.split('.').pop();
      const key = _.get(this.item.document2, 'key', null);
      const size = _.get(info, 'file.size', 0);
      this.setDocument2({
        old_key: key,
        key: data.data.key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    
    removeDocument2() {
      this.setDocument2(null)
      this.setDocumentSlide2([]);
    },
    
    updateDocument3(info, data) {
      if (!_.has(data, 'data.key')) {
        return;
      }
      const extension = data.data.key.split('.').pop();
      const key = _.get(this.item.document3, 'key', null);
      const size = _.get(info, 'file.size', 0);
      this.setDocument3({
        old_key: key,
        key: data.data.key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    
    removeDocument3() {
      this.setDocument3(null)
      this.setDocumentSlide3([]);
    },
    
    updateInterprefy(e) {
      this.interprefy_disabled = true;
      if (e.target.checked) {
        this.interprefy_disabled = false;
        this.setAwsInterpretation(false)
        this.aws_interprefy_disabled = true;
        this.setAwsEnableSpeechToSpeech(false);
        this.setAwsEnableSpeechToText(false);
      }
      this.setInterprefy(e.target.checked);
    },
    
    updateInterprefyToken(e) {
      this.setInterprefyToken(e.target.value);
    },
    
    updateAwsInterpretation(e) {
      this.aws_interprefy_disabled = true;
      if (e.target.checked) {
        this.aws_interprefy_disabled = false;
      }
      if (e.target.checked) {
        this.setInterprefy(false);
        this.interprefy_disabled = true
      }
      this.setAwsInterpretation(e.target.checked);
    },
    
    updateAwsEnableSpeechToSpeech(e) {
      this.setAwsEnableSpeechToSpeech(e.target.checked);
    },
    
    updateAwsEnableSpeechToText(e) {
      this.setAwsEnableSpeechToText(e.target.checked);
    },
    
    createClick() {
      this.setIsNew(true);
      this.setIsEditing(false);
    },
    
    cancelClick() {
      this.resetState();
    },
    
    updateLaguage(value) {
      this.err_translations = null;
      this.setLangKey(value);
      this.languageKey = value;
      this.setLangTitle(null);
      this.setLangDescirption(null);
      if (_.isUndefined(_.find(this.item.translations, { 'key': value }))) {
        let obj = {
          "key": `${value}`,
          "title": null,
          "description": null
        }
        this.item.translations.push(obj);
      } else {
        let selectedLang = _.find(this.item.translations, { 'key': this.selectedLanguageKey })
        if (!_.isUndefined(selectedLang)) {
          this.setLangTitle(selectedLang.title);
          this.setLangDescirption(selectedLang.description);
        }
      }
    },
    
    updateLanguageTitle(e) {
      this.err_translations = null;
      if (!_.isNull(this.selectedLanguageKey) && !_.isEmpty(this.selectedLanguageKey)) {
        this.setTranslations({
          key: this.selectedLanguageKey,
          update_key: 'title',
          update_value: e.target.value
        });
      }
      this.setLangTitle(e.target.value);
    },
    
    updateLanguageDescription(e) {
      if (!_.isNull(this.selectedLanguageKey) && !_.isEmpty(this.selectedLanguageKey)) {
        this.setTranslations({
          key: this.selectedLanguageKey,
          update_key: 'description',
          update_value: e.target.value
        });
      }
      this.setLangDescirption(e.target.value);
    },
    
    getLanguageTitle() {
      return this.selectedLanguageTitle;
    },
    
    getLanguageDescription() {
      return this.selectedLanguageDescirption;
    },
    
    async checkLanguageValidation() {
      let errorsArr = [];
      _.map(this.languages, (item) => {
        let langInfo = _.find(this.item.translations, { 'key': item });
        if (langInfo) {
          if (langInfo.title == null) {
            errorsArr.push(`<li>${item}.title can not be empty.</li>`)
          }
          if (langInfo.description == null) {
            errorsArr.push(`<li>${item}.description can not be empty.</li>`)
          }
          if (langInfo.title !== null && langInfo.title.length < 3) {
            errorsArr.push(`<li>${item}.title atleast 3 character long.</li>`)
          }
          if (langInfo.description !== null && langInfo.description.length < 10) {
            errorsArr.push(`<li>${item}.description atleast 10 character long.</li>`)
          }
        } else {
          errorsArr.push(`<li>${item}.title can not be empty.</li>`)
          errorsArr.push(`<li>${item}.description can not be empty.</li>`)
        }
      });
      return errorsArr;
    },
    
    validate_file(fileInfo) {
      if (_.has(fileInfo, 'key'))
        return fileInfo;
      return null;
    },
    
    async submitForm() {
      const isFormCorrect = await this.v$.$validate();
      let validateTranlation = await this.checkLanguageValidation();
      this.error_general_tab = false;
      this.error_translation_tab = false;
      this.error_theme_tab = false;
      this.error_interpretation_tab = false;
      this.setErrorGeneralTab(false)
      this.setErrorTranslationTab(false)
      let generalError = [];
      _.map(this.v$.$errors, (item) => {
        if (item.$property == "logo") {
          generalError.push("<li>Screen Logo is required</li>");
        }
      });
      if (!_.isEmpty(validateTranlation) && !_.isEmpty(generalError)) {
        this.error_general_tab = true;
        this.error_translation_tab = true;
        this.setErrorTranslationTab(true);
        this.setErrorGeneralTab(true);
      }
      if (!isFormCorrect || !_.isEmpty(validateTranlation)) {
        if (!_.isEmpty(validateTranlation)) {
          this.error_translation_tab = true;
          this.setErrorTranslationTab(true);
          this.$flashMessage.show({
            group: 'meetings_edit',
            type: 'error',
            time: 1000,
            title: 'Failed',
            html: `<ul>${validateTranlation.join("")}</ul>`
          });
          return;
        }
      }
      if (!isFormCorrect) {
        if (!_.isEmpty(generalError)) {
          this.error_general_tab = true;
          this.setErrorGeneralTab(true);
          this.$flashMessage.show({
            group: 'meetings_edit',
            type: 'error',
            time: 1000,
            title: 'Failed',
            html: `<ul>${generalError.join("")}</ul>`
          });
          return;
        }
        return
      }
      this.updateData()
        .then(async () => {
          await this.fetchAllData(this.$route.params.event_id);
          this.$flashMessage.show({
            group: 'meetings_index',
            type: 'success',
            title: 'Success',
            time: 1000,
            html: '<ul><li>Meeting has been updated successfully</li></ul>'
          });
        })
        .catch((error) => {
          console.error("Error update panel discussion", error)
          let html = gettingErrorMessage(error);
          this.$flashMessage.show({
            group: 'meetings_edit',
            type: 'error',
            title: 'Error',
            text: html || 'Something went wrong.',
            html: html
          });
        })
    },
    
    updateSkybox_is_custom(e) {
      this.setSkybox_is_custom(e.target.checked);
    },
    
    updateEnvironment_is_custom(e) {
      this.setEnvironment_is_custom(e.target.checked);
    },
    
    removeSkyboxPicture(e) {
      this.setSkyboxPicture(null);
    },
    
    removeEnvironmentPicture(e) {
      this.setEnvironmentPicture(null);
    },
    
    updateSkyboxPicture(info, data) {
      if (!_.has(data, 'data.key')) {
        return;
      }
      const extension = data.data.key.split('.').pop();
      const key = _.get(this.item.skybox_picture, 'key', null);
      const size = _.get(info, 'file.size', 0);
      this.setSkyboxPicture({
        old_key: key,
        key: data.data.key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    
    updateEnvironmentPicture(info, data) {
      if (!_.has(data, 'data.key')) {
        return;
      }
      const extension = data.data.key.split('.').pop();
      const key = _.get(this.item.environment_picture, 'key', null);
      const size = _.get(info, 'file.size', 0);
      this.setEnvironmentPicture({
        old_key: key,
        key: data.data.key,
        temp_key: info.id,
        size: size.toString(),
        extension: extension,
        uploadedBy: info.user.first_name + ' ' + info.user.last_name,
        uploadedAt: '2023.01.01',
      });
    },
    
    updateSkybox(e) {
      this.setSkybox(e.target.value);
    },
    
    updateEnvironment(e) {
      this.setEnvironment(e.target.value);
    },
    
    async updateVerticalBanners(e) {
      try {
        let image_qty = 4;
        let totalDocs = this.item.vertical_banners.length + e.target.files.length;
        if (totalDocs > image_qty) {
          alert(`You can not upload more than ${image_qty} Banners in the Meetings`);
          return;
        }
        const files = e.target.files;
        for (let file of files) {
          let file_size = file.size;
          let img_ext = file.name.split('.').pop().toLowerCase();
          if (['jpg', 'jpeg'].includes(img_ext) == false) {
            this.errCb();
            return;
          }
        }
        const user = JSON.parse(localStorage.getItem('user'));
        for (let file of files) {
          let file_size = file.size;
          let id = ObjectID();
          let resp = await upload(file, id, "meetings", '720X1800', 'banners');
          let fileKey = resp.data.data.key ? resp.data.data.key : resp.data.data.Key;
          let extension = fileKey.split('.').pop();
          this.setVerticalBanners({
            key: fileKey,
            old_key: fileKey,
            temp_key: id,
            size: file_size.toString(),
            extension: extension,
            uploadedBy: user.first_name + ' ' + user.last_name,
            uploadedAt: '2023.01.01',
          });
        }
      } catch (e) {
        console.log("Error in set", e);
        this.$flashMessage.show({
          group: 'meetings_edit',
          type: 'error',
          title: 'Error',
          html: "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"
        });
      }
    },
    
    removeVerticalBannerAsset(e, id) {
      console.log("removeid", id);
      this.$swal({
        title: "Are you sure?",
        text: "To fully delete the file submit the form.",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        confirmButtonColor: "#dd4b39",
        focusCancel: true,
        reverseButtons: true
      }).then(result => {
        if (typeof result.dismiss === "undefined") {
          remove(id).then(() => {
            this.removeVerticalBanners(id);
          })
        }
      });
    },
    
    onMatchMakingSaved() {
      // Handle match making saved event
    },
    
    // Day tabs pagination methods
    initDaysTabs() {
      this.$nextTick(() => {
        this.daysTabScrollWrapper = this.$refs.daysTabsScrollWrapper;
        this.daysTabContainer = this.$refs.daysTabs;
        this.calculateDaysPerPage();
        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(() => {
            this.calculateDaysPerPage();
          });
          if (this.daysTabScrollWrapper) {
            this.resizeObserver.observe(this.daysTabScrollWrapper);
          }
        }
      });
    },
    
    handleResize() {
      this.calculateDaysPerPage();
    },
    
    calculateDaysPerPage() {
      if (!this.daysTabScrollWrapper) return;
      const containerWidth = this.daysTabScrollWrapper.clientWidth;
      const tabWidth = 130;
      const possibleTabs = Math.floor(containerWidth / tabWidth);
      this.daysPerPage = Math.max(3, Math.min(possibleTabs, 12));
      if (this.daysTabScrollPosition + this.daysPerPage > this.event_days.length) {
        this.daysTabScrollPosition = Math.max(0, this.event_days.length - this.daysPerPage);
      }
    },
    
    scrollDaysTabs(direction) {
      if (direction === 'next' && !this.daysTabScrollEndReached) {
        this.daysTabScrollPosition = Math.min(
          this.daysTabScrollPosition + this.daysPerPage,
          this.event_days.length - this.daysPerPage
        );
      } else if (direction === 'prev' && this.daysTabScrollPosition > 0) {
        this.daysTabScrollPosition = Math.max(0, this.daysTabScrollPosition - this.daysPerPage);
      }
    },
    
    setActiveDay(index) {
      this.activeDayIndex = index;
      this.ensureDayInView(index);
    },
    
    ensureDayInView(dayIndex) {
      if (dayIndex < this.daysTabScrollPosition) {
        this.daysTabScrollPosition = dayIndex;
      } else if (dayIndex >= this.daysTabScrollPosition + this.daysPerPage) {
        this.daysTabScrollPosition = Math.max(0, dayIndex - this.daysPerPage + 1);
      }
    },
    
    scrollToDay() {
      this.ensureDayInView(this.activeDayIndex);
    },
    
    getActualDayIndex(paginatedIndex) {
      return this.daysTabScrollPosition + paginatedIndex;
    },
    
    hasDayErrors(dayIndex) {
      const daySettings = this.item.room_settings?.[dayIndex];
      if (!daySettings || !daySettings.has_meetings) return false;
      return (!daySettings.start_time || !daySettings.end_time || !daySettings.time_slot);
    },
    
    truncateDayName(day, maxLength = 20) {
      if (day.length <= maxLength) return day;
      return day.substring(0, maxLength) + '...';
    }
  }
}
</script>

<style lang="scss" scoped>
.labelwrapper {
  display: flex;
  justify-content: space-around;
}

.labelwrapper label {
  display: block;
}

.toggle.active i.fa-minus {
  display: none !important;
}

.toggle>label {
  background: #fff !important;
}

.fas .fa-minus {
  display: none !important;
}

.v-dialog>.v-overlay__content>.v-card {
  border-radius: 15px;
  padding-top: 20px;
}

html .toggle-primary .toggle.active>label .labelwrapper span label {
  color: #ffffff !important;
}

.question_wrapper {
  background: #efefef;
  padding: 20px;
  margin-bottom: 15px;
  position: relative;
}

.question {
  font-weight: bold;
  margin-bottom: 10px;
}

.question_action {
  position: absolute;
  top: 50%;
  right: 50px;
}

.question_edit {
  background: #1896e3;
  color: #fff;
  padding: 8px 20px;
  border-radius: 5px;
  text-decoration: none;
  margin-right: 5px;
  box-shadow: 0px 1px 2px 0px #999;
  cursor: pointer;
}

.question_delete {
  background: #fff;
  color: #5a5757;
  padding: 8px 20px;
  border-radius: 5px;
  text-decoration: none;
  box-shadow: 0px 1px 2px 0px #999;
  cursor: pointer;
}

.newbtn {
  border: 1px solid #cccccc;
  padding: 10px;
  border-radius: 5px;
}

.vue__time-picker-input {
  display: block !important;
  width: 150% !important;
  padding: 0.375rem 0.75rem !important;
  font-size: 0.8rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #212529 !important;
  background-color: #fff !important;
  background-clip: padding-box !important;
  border: 1px solid #ced4da !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-radius: 0.375rem !important;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out !important;
  height: 2.85em !important
}

.vue__time-picker .controls {
  left: 200px !important
}

// Enhanced Day Tabs Styles
.days-tabs-container {
  margin-top: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: white;
}

.days-tabs-nav {
  display: flex;
  align-items: center;
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  position: relative;
  padding: 5px 0;
}

.nav-arrow {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 8px 12px;
  margin: 0 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1;
  
  &:hover:not(:disabled) {
    background: #e9ecef;
    border-color: #adb5bd;
    transform: scale(1.05);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  i {
    font-size: 14px;
  }
}

.days-tabs-scroll-wrapper {
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 2px;
    
    &:hover {
      background: #555;
    }
  }
}

.days-tabs {
  display: flex;
  flex-wrap: nowrap;
  min-width: min-content;
}

.day-tab {
  flex: 0 0 auto;
  padding: 12px 20px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 500;
  position: relative;
  white-space: nowrap;
  
  &:hover {
    background: #f8f9fa;
    color: #495057;
  }
  
  &.active {
    color: #007bff;
    border-bottom-color: #007bff;
    background: white;
  }
  
  .day-error-badge {
    position: absolute;
    top: 2px;
    right: 2px;
    background: #dc3545;
    color: white;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    font-size: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }
}

.days-tabs-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border-top: 1px solid #dee2e6;
  
  .days-info-left {
    display: flex;
    gap: 15px;
    align-items: center;
  }
  
  .days-counter {
    font-size: 13px;
    color: #6c757d;
    font-weight: 500;
  }
  
  .page-counter {
    font-size: 12px;
    color: #007bff;
    background: #e7f1ff;
    padding: 2px 8px;
    border-radius: 12px;
  }
  
  .day-jump-select {
    padding: 6px 12px;
    font-size: 13px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    background: white;
    cursor: pointer;
    min-width: 250px;
    
    &:hover {
      border-color: #adb5bd;
    }
    
    &:focus {
      outline: none;
      border-color: #007bff;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
  }
}

.day-content {
  padding: 20px;
  max-height: 600px;
  overflow-y: auto;
}

.day-content-pane {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// Image list styles
.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-top: 15px;
  
  .image-item {
    position: relative;
    width: 150px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    overflow: hidden;
    
    img {
      width: 100%;
      height: 100px;
      object-fit: cover;
    }
    
    .image-details {
      padding: 8px;
      background: #f8f9fa;
      
      .image-name {
        font-size: 11px;
        display: block;
        margin-bottom: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      
      .remove-btn {
        width: 100%;
        padding: 4px;
        background: #dc3545;
        color: white;
        border: none;
        border-radius: 3px;
        cursor: pointer;
        font-size: 11px;
        
        &:hover {
          background: #c82333;
        }
      }
    }
  }
}

// Responsive styles
@media (max-width: 768px) {
  .days-tabs-nav {
    .nav-arrow {
      padding: 6px 10px;
    }
  }
  
  .day-tab {
    padding: 10px 16px;
    font-size: 12px;
  }
  
  .days-tabs-info {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
    
    .days-info-left {
      justify-content: space-between;
    }
    
    .day-jump-select {
      width: 100%;
      min-width: auto;
    }
  }
  
  .day-content {
    padding: 15px;
  }
}
</style>